<template>
	<div>
		<div class="form-title" style="margin-bottom: 20px">Tạo mật khẩu mới</div>
		<div style="
            color: var(--3B3B3B, #3c3c3c);

            text-align: center;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px; /* 150% */
            margin-bottom: 20px;
          ">
			Tạo một mật khẩu mạnh có kết hợp của các chữ cái, số và ký hiệu
		</div>

		<div class="main-form">
			<div class="input-wrapper" style="position: relative">
				<label for="password">Mật khẩu</label>
				<input v-model="password" :type="this.showPassword ? 'text' : 'password'" id="password" placeholder="Nhập mật khẩu" style="padding-right: 50px" maxlength="32"
					v-on:keypress="regex($event)" v-on:keyup="checkInput" v-on:focus="focusField" @copy.prevent @paste.prevent />
				<img v-if="this.showPassword" class="toggle-password" src="@/assets/images/hidden.png" @click="this.showPassword = !this.showPassword"/>
				<img v-else class="toggle-password" src="@/assets/images/display.png" @click="this.showPassword = !this.showPassword"/>
				<small class="warning" v-show="showWarningPassword">
					<img src="@/assets/images/warning.png" alt="" />{{ textWarinngPassword }}
				</small>
			</div>
			<div class="input-wrapper" style="position: relative">
				<label for="re-password">Xác nhận mật khẩu</label>
				<input v-model="passwordConfirm" :type="this.showPasswordConfirm ? 'text' : 'password'" id="re-password" placeholder="Xác nhận mật khẩu" maxlength="32"
					v-on:keypress="regex($event)" v-on:keyup="checkConfirmPassword" @copy.prevent @paste.prevent/>

				<img v-if="this.showPasswordConfirm" class="toggle-password" src="@/assets/images/hidden.png" @click="this.showPasswordConfirm = !this.showPasswordConfirm"/>
				<img v-else class="toggle-password" src="@/assets/images/display.png" @click="this.showPasswordConfirm = !this.showPasswordConfirm"/>
				<small class="warning" v-show="showWarningPasswordConfirm">
					<img src="@/assets/images/warning.png" alt="" />{{ textWarinngPasswordConfirm }}
				</small>
			</div>
		</div>

		<a href="javascript:void(0)" :class="{ 'blur': disableBtnNext}" v-on="disableBtnNext ? { } : {click: forgotpassStep3}" class="btn-next cursor-pointer" style="margin-bottom: 40px">Tiếp theo</a>

		<a href="javascript:void(0)" class="btn-back" style="margin-bottom: 100px" @click="backStep">
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
				<path
					d="M6.72488 10.4525L13.6911 17.09C13.8074 17.2008 13.9618 17.2626 14.1224 17.2626C14.283 17.2626 14.4374 17.2008 14.5536 17.09L14.5611 17.0825C14.6177 17.0287 14.6627 16.9641 14.6935 16.8924C14.7242 16.8207 14.7401 16.7436 14.7401 16.6656C14.7401 16.5876 14.7242 16.5104 14.6935 16.4387C14.6627 16.3671 14.6177 16.3024 14.5611 16.2487L8.00113 9.9987L14.5611 3.7512C14.6177 3.69749 14.6627 3.63283 14.6935 3.56116C14.7242 3.4895 14.7401 3.41232 14.7401 3.33433C14.7401 3.25634 14.7242 3.17916 14.6935 3.10749C14.6627 3.03583 14.6177 2.97117 14.5611 2.91745L14.5536 2.90995C14.4374 2.79915 14.283 2.73733 14.1224 2.73733C13.9618 2.73733 13.8074 2.79915 13.6911 2.90995L6.72488 9.54745C6.66362 9.60582 6.61484 9.67603 6.58152 9.75381C6.54819 9.83159 6.53101 9.91533 6.53101 9.99995C6.53101 10.0846 6.54819 10.1683 6.58152 10.2461C6.61484 10.3239 6.66362 10.3941 6.72488 10.4525Z"
					fill="#0355CE" />
			</svg>
			Quay lại
		</a>
	</div>
</template>
<script>
import { useForgotPassStore } from "@/store";
export default {
	data() {
		const forgotPassStore = useForgotPassStore();
		return {
			forgotPassStore,
			password: "",
			passwordConfirm: "",
			showWarningPassword: false,
			textWarinngPassword: "Mật khẩu không hợp lệ",
			showWarningPasswordConfirm: false,
			textWarinngPasswordConfirm: "Mật khẩu không hợp lệ",
			disableBtnNext: true,
			showPassword: false,
			showPasswordConfirm: false
		};
	},
	methods: {
		backStep() {
			this.$router.push({
				name: 'forgotpassconfirmsecure', params: {}
			});
		},
		forgotpassStep3() {
			const forgotPassStore = useForgotPassStore();
			forgotPassStore.newPassword = this.password;
			forgotPassStore.newPasswordConfirm = this.passwordConfirm;
			forgotPassStore.forgotpass(3)
				.then((response) => {
					if (response.ResponseCode > 0) {
						this.$swal.fire({
							icon: "success",
							title: "Thông báo!",
							text: response.Description
						});
						this.$router.push({
							name: 'forgotpassdefault',
							params: {}
						});
						return;
					}
					this.textWarinngPassword = this.$t(`forgotpass.${response.ResponseCode}`, {}, response.Description);
					this.showWarningPassword = true;
					return;
				})
				.catch((error) => {
					console.error(error);
					this.textWarinngPassword = "Hệ thống đang bận vui lòng thử lại sau";
					this.showWarningPassword = true;
				});
		},
		checkInput() {
			let check = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{4,32}$/g.test(this.password);
			if (!check) {
				this.textWarinngPassword = "Mật khẩu có độ dài từ 4-32 ký tự chữ, số, ký tự đặc biệt";
				this.disableBtnNext = true;
				this.showWarningPassword = true;
				return;
			}

			this.textWarinngPassword = "";
			this.showWarningPassword = false;

			if (this.password != this.passwordConfirm) {
				this.textWarinngPasswordConfirm = "Mật khẩu xác nhận phải trùng với mật khẩu đã nhập";
				this.disableBtnNext = true;
				this.showWarningPasswordConfirm = true;
				return;
			}

			this.textWarinngPasswordConfirm = "";
			this.showWarningPasswordConfirm = false;
			this.disableBtnNext = false;
		},
		checkConfirmPassword() {
			let check = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{4,32}$/g.test(this.passwordConfirm);
			if (!check) {
				this.textWarinngPasswordConfirm = "Mật khẩu có độ dài từ 4-32 ký tự chữ, số, ký tự đặc biệt";
				this.showWarningPasswordConfirm = true;
				this.disableBtnNext = true;
				return;
			}
			this.textWarinngPasswordConfirm = "";
			this.showWarningPasswordConfirm = false;

			if (this.password != this.passwordConfirm) {
				this.textWarinngPasswordConfirm = "Mật khẩu xác nhận phải trùng với mật khẩu đã nhập";
				this.disableBtnNext = true;
				this.showWarningPasswordConfirm = true;
				return;
			}
			this.textWarinngPasswordConfirm = "";
			this.showWarningPasswordConfirm = false;
			this.disableBtnNext = false;
		},
		regex(e){
			let char = String.fromCharCode(e.keyCode); // Get the character
			let checkSo = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]$/g.test(char);
			if(checkSo) return true;
			e.preventDefault();
		},
		focusField(){
			this.textWarinngPassword = "Mật khẩu có độ dài từ 4-32 ký tự chữ, số, ký tự đặc biệt";
			this.showWarningPassword = true;
		}
	},
};
</script>
<style lang="">
</style>